function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import AmbulatoryGlucoseProfile from 'modules/AmbulatoryGlucoseProfile';
import messages from 'modules/AmbulatoryGlucoseProfile/messages';
import BgmValuesInRangesReportChart from 'components/Charts/BgmValuesInRangesChart/BgmValuesInRangesReportChart';
import SectionTitle from '../components/SectionTitle';
import * as constants from '../../../constants';
import styles from './TimeInRangesSection.pcss';
var _React_Component;
class TimeInRangesSection extends (_React_Component = React.Component) {
    render() {
        const { conversion, statistics } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.timeInRangesSectionWrapper,
            children: [
                /*#__PURE__*/ _jsx(SectionTitle, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.bgmValuesInRanges))
                }),
                /*#__PURE__*/ _jsx(BgmValuesInRangesReportChart, {
                    conversion: this.props.conversion,
                    standards: this.props.standards,
                    timeInRanges: [
                        {
                            name: 'veryHigh',
                            count: statistics.veryHighCount,
                            percent: Math.round(statistics.veryHigh * 100),
                            range: `>${constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].veryHigh}`
                        },
                        {
                            name: 'high',
                            count: statistics.highCount,
                            percent: Math.round(statistics.high * 100),
                            range: `${constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].high + constants.GLUCOSE_CONCENTRATION_LEVEL_STEP[conversion.unit]} - ${constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].veryHigh}`
                        },
                        {
                            name: 'normal',
                            count: statistics.targetCount,
                            percent: Math.round(statistics.target * 100),
                            range: `${constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].target} - ${constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].high}`
                        },
                        {
                            name: 'low',
                            count: statistics.lowCount,
                            percent: Math.round(statistics.low * 100),
                            range: `${constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].low} - ${constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].target - constants.GLUCOSE_CONCENTRATION_LEVEL_STEP[conversion.unit]}`
                        },
                        {
                            name: 'veryLow',
                            count: statistics.veryLowCount,
                            percent: Math.round(statistics.veryLow * 100),
                            range: `<${constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES[conversion.unit].low}`
                        }
                    ]
                })
            ]
        });
    }
}
_define_property(TimeInRangesSection, "propTypes", {
    // Explicit props
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    // Implicit props
    statistics: PropTypes.shape({
        veryHigh: PropTypes.number,
        high: PropTypes.number,
        target: PropTypes.number,
        low: PropTypes.number,
        veryLow: PropTypes.number,
        veryHighCount: PropTypes.number,
        highCount: PropTypes.number,
        targetCount: PropTypes.number,
        lowCount: PropTypes.number,
        veryLowCount: PropTypes.number
    }),
    isDisplayedGlucoseStatistics: PropTypes.bool,
    isDisplayedTimeInRanges: PropTypes.bool
});
const mapStateToProps = (state)=>({
        statistics: AmbulatoryGlucoseProfile.selectors.highlightedStatisticsFactory(constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES)(state),
        isDisplayedGlucoseStatistics: AmbulatoryGlucoseProfile.selectors.isDisplayedGlucoseStatistics(state),
        isDisplayedTimeInRanges: AmbulatoryGlucoseProfile.selectors.isDisplayedTimeInRanges(state)
    });
const ConnectedTimeInRangesSection = connect(mapStateToProps)(TimeInRangesSection);
export default withStyles(styles)(ConnectedTimeInRangesSection);
